import { render, staticRenderFns } from "./attribute-add-or-update.vue?vue&type=template&id=31f1fdd1&"
import script from "./attribute-add-or-update.vue?vue&type=script&lang=js&"
export * from "./attribute-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports